<main class="device-page">
  <header class="device-header">
    <div>
      <p class="eyebrow">{{ 'dashboard.deviceEyebrow' | transloco }}</p>
      <h1>{{ new ? titleDevice : ('device.titleOperational' | transloco:{ serial: serial_number_Input }) }}</h1>
      <dl class="device-summary" *ngIf="!new">
        <div><dt>{{ 'dashboard.columns.project' | transloco }}</dt><dd>{{ headerDevice?.project_name || ('dashboard.noProject' | transloco) }}</dd></div>
        <div><dt>{{ 'dashboard.columns.zone' | transloco }}</dt><dd>{{ headerDevice?.zone_name || '—' }}</dd></div>
        <div><dt>{{ 'dashboard.columns.status' | transloco }}</dt><dd><span class="device-status-chip" [class.alarm]="headerStatus === 'alarm'">{{ headerStatus ? (('dashboard.status.' + headerStatus) | transloco) : '—' }}</span></dd></div>
        <div><dt>{{ 'dashboard.columns.lastSeen' | transloco }}</dt><dd>{{ headerLastTelemetryAt ? (headerLastTelemetryAt | companyDate) : ('dashboard.telemetry.noDataShort' | transloco) }}</dd></div>
        <div><dt>{{ 'dashboard.columns.battery' | transloco }}</dt><dd>{{ headerBattery === null ? '—' : headerBattery + '%' }}</dd></div>
        <div><dt>{{ 'device.primaryWorker' | transloco }}</dt><dd>{{ headerDevice?.user_name || ('dashboard.unassigned' | transloco) }}</dd></div>
      </dl>
    </div>
    <button mat-stroked-button routerLink="/devices"><mat-icon>arrow_back</mat-icon>{{ 'device.cancel' | transloco }}</button>
  </header>

  <ng-container *ngIf="new; else existingDevice">
    <section class="content-panel"><ng-container *ngTemplateOutlet="detailsForm"></ng-container></section>
  </ng-container>

  <ng-template #existingDevice>
    <section class="content-panel tab-panel">
      <mat-tab-group animationDuration="150ms" mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedTabIndex">
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>monitoring</mat-icon><span>{{ 'dashboard.tabs.telemetry' | transloco }}</span></ng-template>
          <div class="tab-content"><app-device-operations [companyId]="companyId" [deviceId]="id_number_Input" [focusAt]="alarmAt" [latestTelemetry]="headerLatestTelemetry" mode="telemetry"></app-device-operations></div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>info</mat-icon><span>{{ 'dashboard.tabs.details' | transloco }}</span></ng-template>
          <div class="tab-content editor-tab"><ng-container *ngTemplateOutlet="detailsForm"></ng-container></div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>notifications</mat-icon><span>{{ 'dashboard.tabs.notifications' | transloco }}</span></ng-template>
          <div class="tab-content notification-tab"><ng-container *ngTemplateOutlet="notifications"></ng-container></div>
        </mat-tab>
        <mat-tab *ngIf="storageService.roleId <= 3">
          <ng-template mat-tab-label><mat-icon>settings</mat-icon><span>{{ 'dashboard.tabs.configuration' | transloco }}</span></ng-template>
          <div class="tab-content configuration-tab">
            <app-configuration [data]="{ device_id: id_number_Input, company_id: companyId, serial_number: serial_number_Input }" [inline]="true"></app-configuration>
            <ng-container *ngTemplateOutlet="retention"></ng-container>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>history</mat-icon><span>{{ 'dashboard.tabs.alarmHistory' | transloco }}</span></ng-template>
          <div class="tab-content"><app-device-operations [companyId]="companyId" [deviceId]="id_number_Input" mode="alarms"></app-device-operations></div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>manage_history</mat-icon><span>{{ 'device.activity' | transloco }}</span></ng-template>
          <div class="tab-content activity-tab">
            <p class="activity-help">{{ 'device.activityHelp' | transloco }}</p>
            <p *ngIf="activityLoading">{{ 'device.activityLoading' | transloco }}</p>
            <p *ngIf="!activityLoading && activity.length === 0" class="empty-state">{{ 'device.activityEmpty' | transloco }}</p>
            <ol *ngIf="!activityLoading && activity.length > 0" class="activity-list">
              <li *ngFor="let item of activity">
                <div class="activity-marker"><mat-icon>history</mat-icon></div>
                <div>
                  <strong>{{ ('device.activityFields.' + item.field) | transloco }}</strong>
                  <p>{{ item.old_value || '—' }} <mat-icon>arrow_forward</mat-icon> {{ item.new_value || '—' }}</p>
                  <small>{{ item.actor_name }} · {{ item.occurred_at | companyDate }}</small>
                </div>
              </li>
            </ol>
          </div>
        </mat-tab>
      </mat-tab-group>
    </section>
  </ng-template>

  <ng-template #detailsForm>
    <form class="device-form" #f="ngForm" (ngSubmit)="onGuardarItm(f)">
      <div class="form-grid">
        <mat-form-field appearance="outline" *ngIf="storageService.roleId === 1">
          <mat-label>{{ 'device.id' | transloco }}</mat-label>
          <input matInput type="number" name="id_number" [disabled]="!new" [(ngModel)]="id_number_Input" required>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'device.sn' | transloco }}</mat-label>
          <input matInput type="text" name="serial_number" [disabled]="storageService.roleId !== 1 || lockSn" [(ngModel)]="serial_number_Input" required maxlength="64">
          <button *ngIf="!lockSn && storageService.roleId === 1" mat-icon-button matSuffix (click)="scan()" type="button" [matTooltip]="'scanner.label' | transloco"><mat-icon>qr_code_scanner</mat-icon></button>
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="storageService.roleId === 1">
          <mat-label>{{ 'device.company' | transloco }}</mat-label>
          <mat-select [(ngModel)]="company_Selected" name="company" (selectionChange)="onSelectCompany($event.value)" required>
            @for (item of lstCompanies; track item) { <mat-option [value]="item.value">{{ item.viewValue }}</mat-option> }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'device.project' | transloco }}</mat-label>
          <mat-select [(value)]="project_Selected" (selectionChange)="onSelectProject($event.value)" [disabled]="storageService.roleId > 3">
            <mat-option [value]="0">{{ 'device.unassigned' | transloco }}</mat-option>
            @for (itemProject of lstProjects; track itemProject) { @if (itemProject.value) { <mat-option [value]="itemProject.value">{{ itemProject.viewValue }}</mat-option> } }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'device.zones' | transloco }}</mat-label>
          <mat-select [(value)]="zone_Selected" [disabled]="!project_Selected || storageService.roleId > 3">
            <mat-option [value]="0">{{ 'device.unassigned' | transloco }}</mat-option>
            @for (itemZone of lstProjectZones; track itemZone) { @if (itemZone.value) { <mat-option [value]="itemZone.value">{{ itemZone.viewValue }}</mat-option> } }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'device.primaryWorker' | transloco }}</mat-label>
          <mat-select [(value)]="worker_Selected" [disabled]="storageService.roleId > 3">
            <mat-option [value]="0">{{ 'device.unassigned' | transloco }}</mat-option>
            @for (worker of lstWorkers; track worker) { <mat-option [value]="worker.value">{{ worker.viewValue }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-actions">
        <button mat-flat-button color="primary" *ngIf="storageService.roleId <= 3" type="submit"><mat-icon>save</mat-icon>{{ 'device.save' | transloco }}</button>
        <button mat-stroked-button color="warn" *ngIf="!new && storageService.roleId === 1" type="button" (click)="onEliminarItm()"><mat-icon>delete</mat-icon>{{ 'device.delete' | transloco }}</button>
      </div>
    </form>
  </ng-template>

  <ng-template #notifications>
    <section class="notification-section">
      <div class="notification-column">
        <h2>{{ 'dashboard.notifications.externalEmails' | transloco }}</h2>
        <p>{{ 'dashboard.notifications.externalEmailsHelp' | transloco }}</p>
        <div class="add-row" *ngIf="storageService.roleId <= 3">
          <mat-form-field appearance="outline"><mat-label>{{ 'dashboard.notifications.addEmail' | transloco }}</mat-label><input matInput type="email" [(ngModel)]="emailToAdd" (keyup.enter)="addNotificationEmail()" maxlength="128"></mat-form-field>
          <button class="add-contact-button" mat-icon-button type="button" (click)="addNotificationEmail()" [matTooltip]="'dashboard.notifications.addEmail' | transloco" [attr.aria-label]="'dashboard.notifications.addEmail' | transloco"><mat-icon>add</mat-icon></button>
        </div>
        <mat-error *ngIf="invalidEmailToAdd">{{ 'dashboard.notifications.invalidEmail' | transloco }}</mat-error>
        <div class="tag-list">
          <div *ngFor="let email of notificationEmailsList" class="contact-tag" [class.inherited]="email.origin === 'project'">
            <mat-icon>email</mat-icon><span>{{ email.email }}</span><mat-icon *ngIf="email.origin === 'project'" [matTooltip]="'dashboard.notifications.inherited' | transloco">lock</mat-icon>
            <button *ngIf="storageService.roleId <= 3 && email.origin !== 'project'" class="notification-remove-button" mat-icon-button type="button" (click)="removeNotificationEmail(email.id)"><mat-icon>close</mat-icon></button>
          </div>
        </div>
      </div>
      <div class="notification-column">
        <h2>{{ 'dashboard.notifications.internalUsers' | transloco }}</h2>
        <p>{{ 'dashboard.notifications.internalUsersHelp' | transloco }}</p>
        <div class="add-row" *ngIf="storageService.roleId <= 2">
          <mat-form-field appearance="outline"><mat-label>{{ 'dashboard.notifications.addUser' | transloco }}</mat-label><mat-select [(ngModel)]="userToAdd">@for (user of lstCompanyUsers; track user) { <mat-option [value]="user.value">{{ user.viewValue }}</mat-option> }</mat-select></mat-form-field>
          <button class="add-contact-button" mat-icon-button type="button" (click)="addNotificationUser()" [matTooltip]="'dashboard.notifications.addUser' | transloco" [attr.aria-label]="'dashboard.notifications.addUser' | transloco"><mat-icon>person_add</mat-icon></button>
        </div>
        <div class="tag-list">
          <div *ngFor="let contact of notificationContactsList" class="contact-tag" [class.inherited]="contact.origin === 'project'">
            <mat-icon>person</mat-icon><span>{{ contact.first_name }} {{ contact.last_name }}</span><mat-icon *ngIf="contact.origin === 'project'" [matTooltip]="'dashboard.notifications.inherited' | transloco">lock</mat-icon>
            <button *ngIf="storageService.roleId <= 2 && contact.origin !== 'project'" class="notification-remove-button" mat-icon-button type="button" (click)="removeNotificationUser(contact.id)"><mat-icon>close</mat-icon></button>
          </div>
        </div>
      </div>
    </section>
  </ng-template>

  <ng-template #retention>
    <section class="retention-section">
      <div><h2>{{ 'dashboard.notifications.retentionTitle' | transloco }}</h2><p>{{ 'dashboard.notifications.retentionHelp' | transloco }}</p></div>
      <mat-form-field class="retention-control" appearance="outline">
        <mat-label>{{ 'dashboard.notifications.retentionTime' | transloco }}</mat-label>
        <mat-select [(ngModel)]="retentionTime" [disabled]="!retentionTimeInitialized">
          <mat-option [value]="null">{{ 'dashboard.notifications.noRetention' | transloco }}</mat-option>
          <mat-option *ngFor="let minutes of [1, 2, 5, 10, 15]" [value]="minutes">{{ minutes }} min</mat-option>
        </mat-select>
      </mat-form-field>
      <button class="settings-action" mat-flat-button color="primary" type="button" [disabled]="!retentionTimeInitialized" (click)="saveRetentionTime()"><mat-icon>save</mat-icon>{{ 'dashboard.notifications.updateRetention' | transloco }}</button>
    </section>
  </ng-template>
</main>
